angular.module('iqxCore')
  
  .service('PasswordStrength', function () {
    this.adequate=function(sPassword,oOptions) {
      var sRegex=''
      
      if(oOptions.digits){
        sRegex+='(?=.*\\d)'  // backslash must be doubled because of normal use as escape char in string
      }
      
      if(oOptions.capitals){
        sRegex+='(?=.*[A-Z])'
      }
      
      if(oOptions.punctuation){
        sRegex+='(?=.*\\W)'   // backslash must be doubled because of normal use as escape char in string
      }
      
      if(oOptions.minLength){
        sRegex+='.{'+oOptions.minLength.toString()+',}'
      }
      
      var regex=new RegExp(sRegex)
      return regex.test(sPassword)
    }
  })

  
  .directive('enforcePasswordStrength', ['PasswordStrength',
    function(PasswordStrength) {
      return {
        require: "ngModel",
        restrict: 'A',
        link: function(scope, elem, attrs, ngModel) {
          ngModel.$validators.passwordStrength=function(modelValue) {
            var opts={}
            scope.passwordOpts()
            opts.digits=scope.passwordOptions.number
            opts.capitals=scope.passwordOptions.uppercase
            opts.punctuation=scope.passwordOptions.special
            if (scope.passwordOptions.minimum) {
              opts.minLength=scope.passwordOptions.minlength
            }            
            return PasswordStrength.adequate(modelValue,opts)
          }
        }
      }
    }
  ])           

  .directive('matchField', [
    function() {
      return {
        require: "ngModel",
        restrict: 'A',
        scope: {
          otherModelValue: "=matchField"
        },
        link: function(scope, element, attributes, ngModel) {
          ngModel.$validators.matchField = function(modelValue) {
            return (modelValue == scope.otherModelValue)
          }
          scope.$watch("otherModelValue", function() {
            ngModel.$validate()
          })
        }
      }
    }
  ])
  